import React from "react";
import Hoodie from "../../assets/product_images/Menu_Hoodie.svg";
import HoodieZip from "../../assets/product_images/Menu_Hoodie_zip.svg";
import HoodieWoman from "../../assets/product_images/Menu_Hoodie_women.svg";
import HoodieSnap from "../../assets/product_images/Menu_Hoodie_Snap.svg";
import Mockneck from "../../assets/product_images/Menu_Mockneck.svg";
import MockneckZip from "../../assets/product_images/Menu_Mockneck_zip.svg";
import Pullover from "../../assets/product_images/Menu_Pullover.svg";
import PolarVest from "../../assets/product_images/Menu_Polar_Vest.svg";
import PulloverZip from "../../assets/product_images/Menu_Pullover_Zip.svg";
import SleevelessVest from "../../assets/product_images/Menu_Sleeveless.svg";
import SweatPants from "../../assets/product_images/Menu_Sweatpants.svg";
import TShirt from "../../assets/product_images/Menu_T-shirt.svg";
import WomanTShirt from "../../assets/product_images/Menu_T-shirt_women.svg";
import Sleevelees_Jacket_M from "../../assets/product_images/Sleevelees_Jacket_M.svg";
import Sleevelees_Jacket_W from "../../assets/product_images/Sleevelees_Jacket_W.svg";
import PoloM from "../../assets/product_images/Polo_M.svg";
import PoloW from "../../assets/product_images/Polo_W.svg";
//import Mask from "../../assets/product_images/Menu_Mask.svg";
import Beanie from "../../assets/product_images/Menu_Beanie.svg";
import BeanieWaffle from "../../assets/product_images/Menu_Waffle_Beanie.svg";
import BeaniePompom from "../../assets/product_images/Menu_Pompom_Beanie.svg";
import LongSleeve from "../../assets/product_images/Menu_Longsleeve.svg";
import SweatShirt from "../../assets/product_images/Menu_Sweatshirt.svg";
import CasualSocks from "../../assets/product_images/Menu_Casual_Socks.svg";
import SportSocks from "../../assets/product_images/Menu_Sport_Socks.svg";
import ModalProductImage from "../ModalProductImages";
import { useTranslation } from "react-i18next";

import styles from "./ProductModal.module.scss";
import Close from "@mui/icons-material/Close";

//Temporary, so that in prod we only see the products that are "approved"
const comingSoon = process.env.REACT_APP_ENV === "production";

const products = [
  {
    family: { name: "shirt", version: "1.0" },
    product: { name: "tshirt", version: "1.0" },
    labelTag: "products.tshirt.name",
    imgName: TShirt,
    minQty: 20,
  },
  {
    family: { name: "shirt", version: "1.0" },
    product: { name: "womanTshirt", version: "1.0" },
    labelTag: "products.womanTshirt.name",
    imgName: WomanTShirt,
    minQty: 20,
  },
  {
    family: { name: "shirt", version: "1.0" },
    product: { name: "longsleeve", version: "1.0" },
    labelTag: "products.longsleeve.name",
    imgName: LongSleeve,
    minQty: 20,
  },
  {
    family: { name: "polo", version: "1.0" },
    product: { name: "poloMen", version: "1.0" },
    labelTag: "products.poloMen.name",
    imgName: PoloM,
    minQty: 50,
    comingSoon: comingSoon, //Remove when production has approved this product
  },
  {
    family: { name: "polo", version: "1.0" },
    product: { name: "poloWomen", version: "1.0" },
    labelTag: "products.poloWomen.name",
    imgName: PoloW,
    minQty: 50,
    comingSoon: comingSoon, //Remove when production has approved this product
  },
  {
    family: { name: "sweatshirt", version: "1.0" },
    product: { name: "sweatshirt", version: "1.0" },
    labelTag: "products.sweatshirt.name",
    imgName: SweatShirt,
    minQty: 20,
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodie", version: "1.0" },
    labelTag: "products.hoodie.name",
    imgName: Hoodie,
    minQty: 20,
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieZip", version: "1.0" },
    labelTag: "products.hoodieZip.name",
    imgName: HoodieZip,
    minQty: 20,
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieWoman", version: "1.0" },
    labelTag: "products.hoodieWoman.name",
    imgName: HoodieWoman,
    minQty: 20,
  },
  {
    family: { name: "hoodie", version: "1.0" },
    product: { name: "hoodieSnap", version: "1.0" },
    labelTag: "products.hoodieSnap.name",
    imgName: HoodieSnap,
    minQty: 20,
  },
  {
    family: { name: "pullover", version: "1.0" },
    product: { name: "pulloverSnap", version: "1.0" },
    labelTag: "products.pulloverSnap.name",
    imgName: Pullover,
    minQty: 20,
  },
  {
    family: { name: "pullover", version: "1.0" },
    product: { name: "pulloverZip", version: "1.0" },
    labelTag: "products.pulloverZip.name",
    imgName: PulloverZip,
    minQty: 20,
  },
  {
    family: { name: "pullover", version: "1.0" },
    product: { name: "pulloverFullSnap", version: "1.0" },
    labelTag: "products.pulloverFullSnap.name",
    imgName: PolarVest,
    minQty: 20,
  },
  {
    family: { name: "sleevelessPolar", version: "1.0" },
    product: { name: "sleevelessPolar", version: "1.0" },
    labelTag: "products.sleevelessPolar.name",
    imgName: SleevelessVest,
    minQty: 20,
  },
  {
    family: { name: "mockneck", version: "1.0" },
    product: { name: "mockneck", version: "1.0" },
    labelTag: "products.mockneck.name",
    imgName: Mockneck,
    minQty: 20,
  },
  {
    family: { name: "mockneck", version: "1.0" },
    product: { name: "mockneckFullZip", version: "1.0" },
    labelTag: "products.mockneckFullZip.name",
    imgName: MockneckZip,
    minQty: 20,
  },
  {
    family: { name: "sleevelessJacket", version: "1.0" },
    product: { name: "sleevelessJacketMen", version: "1.0" },
    labelTag: "products.sleevelessJacketMen.name",
    imgName: Sleevelees_Jacket_M,
    minQty: 20,
  },
  {
    family: { name: "sleevelessJacket", version: "1.0" },
    product: { name: "sleevelessJacketWoman", version: "1.0" },
    labelTag: "products.sleevelessJacketWoman.name",
    imgName: Sleevelees_Jacket_W,
    minQty: 20,
  },
  {
    family: { name: "sweatpants", version: "1.0" },
    product: { name: "sweatpants", version: "1.0" },
    labelTag: "products.sweatpants.name",
    imgName: SweatPants,
    minQty: 20,
  },
  {
    family: { name: "beanie", version: "1.0" },
    product: { name: "beanie", version: "1.0" },
    labelTag: "products.beanie.name",
    imgName: Beanie,
    minQty: 20,
  },
  {
    family: { name: "beanie", version: "1.0" },
    product: { name: "waffleBeanie", version: "1.0" },
    labelTag: "products.waffleBeanie.name",
    imgName: BeanieWaffle,
    minQty: 20,
  },
  {
    family: { name: "beanie", version: "1.0" },
    product: { name: "pompomBeanie", version: "1.0" },
    labelTag: "products.pompomBeanie.name",
    imgName: BeaniePompom,
    minQty: 20,
  },
  {
    family: { name: "socks", version: "1.0" },
    product: { name: "casualSocks", version: "1.0" },
    labelTag: "products.casualSocks.name",
    imgName: CasualSocks,
    minQty: 60,
  },
  {
    family: { name: "socks", version: "1.0" },
    product: { name: "sportSocks", version: "1.0" },
    labelTag: "products.sportSocks.name",
    imgName: SportSocks,
    minQty: 60,
  },
  // {
  //   family: { name: "mask", version: "1.0" },
  //   product: { name: "mask", version: "1.0" },
  //   labelTag: "products.mask.name",
  //   imgName: Mask,
  //   minQty: 50,
  //   comingSoon: comingSoon, //Remove when production has approved this product
  // },
];

const ProductModal = (props) => {
  const { t } = useTranslation();
  const { createDesign, onCloseModal } = props;

  return (
    <div className={styles.container}>
      <React.Fragment>
        <Close
          onClick={() => {
            onCloseModal();
          }}
        />
        <h4>{t("products.modal.select_canvas")}</h4>
        <div className={styles.selectionRow}>
          {products.map((product) => (
            <ModalProductImage
              {...product}
              onCreateDesign={createDesign}
              key={product.labelTag}
            />
          ))}
        </div>
      </React.Fragment>
    </div>
  );
};

export default ProductModal;
